import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNoteRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M15.2 7.2H24q.7.1.8.8v16q-.1.7-.8.8H8a1 1 0 0 1-.8-.8v-8.8h4.4c2 0 3.6-1.6 3.6-3.6zm-7 5.6 4.6-4.6v3.4q0 1.1-1.2 1.2zm19-4.8c0-1.8-1.4-3.2-3.2-3.2h-9.9q-1.2 0-2.2 1l-6.2 6q-.9 1-.9 2.3V24c0 1.8 1.4 3.2 3.2 3.2h16c1.8 0 3.2-1.4 3.2-3.2z" })
});
export default SvgNoteRegularIcon;
